import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import DotCoinIcon from "../components/DotCoinIcon";

const Ctx = createContext(null);

export const DotCoinsProvider = ({ children }) => {
  const [balance, setBalance] = useState(null);
  const timer = useRef(null);

  const claim = useCallback(async () => {
    try {
      const { data } = await api.post("/dotcoins/notifications/claim");
      setBalance(data.balance);
      data.items.forEach((i) =>
        toast(`${i.amount > 0 ? "+" : ""}${i.amount} DotCoins`, {
          description: i.description,
          icon: <DotCoinIcon size={20} />,
        })
      );
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    claim();
    const onCheck = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(claim, 400);
    };
    window.addEventListener("dotcoins:check", onCheck);
    return () => window.removeEventListener("dotcoins:check", onCheck);
  }, [claim]);

  return <Ctx.Provider value={{ balance, refresh: claim }}>{children}</Ctx.Provider>;
};

export const useDotCoins = () => useContext(Ctx) || { balance: null, refresh: () => {} };
